import { Injectable } from '@angular/core';
import { PermissionDashboardPage } from '@app/shared/services/api/permission.service';

@Injectable({
  providedIn: 'root',
})
export class ExterneDataStoreService {
  private readonly externeDataKey = 'externeData';

  constructor() {}

  public setExterneData(data: PermissionDashboardPage): void {
    localStorage.setItem(this.externeDataKey, JSON.stringify(data));
  }

  public getExterneData(): PermissionDashboardPage | null {
    const storedData = localStorage.getItem(this.externeDataKey);
    return storedData ? JSON.parse(storedData) : null;
  }

  public removeExterneData(): void {
    localStorage.removeItem(this.externeDataKey);
  }
}
